import Vue from 'vue';
import noty from './noty.service';

export default {
  async getWithdrawalRequestsAsync() {
    return (await Vue.http.get("/api/balance/withdrawal/approval/requests")).data;
  },
  async approveRequestedWithdrawalAsync(options) {
    const result = (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/approval/request/approve`, options)).data;
    result.isSuccess ? noty.success("Approved successfully") : noty.error("Error occurred during approving");
    return result;
  },
  async declineRequestedWithdrawalAsync(options) {
    const result = (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/approval/request/decline`, options)).data;
    result.isSuccess ? noty.success("Declined successfully") : noty.error("Error occurred during declining");
    return result;
  },
  async getBonuses(balanceId) {
    return  (await Vue.http.get(`/api/balance/${balanceId}/bonuses`)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/balance.service.js